import { IconFont } from '@/components/IconFont';
import { isEmpty } from 'radash';
import type { FC } from 'react';
import React, { useCallback, useMemo } from 'react';
import type { NodeProps } from '../../types';
import { NlpExtractNodeType } from './types';

const Node: FC<NodeProps<NlpExtractNodeType>> = ({ data }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const showExpandBtn = useMemo(
    () => data.tags && data.tags?.length > 7,
    [data.tags],
  );
  const displayedTags = useMemo(
    () => (isExpanded ? data.tags : data.tags?.slice(0, 7)),
    [isExpanded, data.tags],
  );

  const toggleExpand = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setIsExpanded((prev) => !prev);
  }, []);

  if (isEmpty(displayedTags?.filter(Boolean))) return null;

  return (
    <>
      <div
        className={`mt-2 transition-all duration-300 ${
          isExpanded ? 'max-h-none' : 'max-h-[200px]'
        } overflow-y-hidden relative`}
      >
        <div className="space-y-2">
          {displayedTags?.map((tag, idx) => (
            <div key={idx} className="rounded-md bg-[#F4F7FF] px-2 py-1 ">
              <div className="text-sm">
                {tag.table_name && `${tag.table_name} - `}
                {tag.tag_name}
              </div>
            </div>
          ))}
        </div>
        {!isExpanded && showExpandBtn && (
          <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white to-transparent" />
        )}
      </div>
      {showExpandBtn && (
        <div
          onClick={toggleExpand}
          className="relative -bottom-1 text-[#8B8F97] flex items-center justify-center cursor-pointer"
        >
          <span className="text-sm">{isExpanded ? '收起' : '展开'}</span>
          <IconFont
            type="icon-xiangxia"
            className={`ml-1 transition-transform duration-300 ${
              isExpanded ? 'rotate-180' : ''
            }`}
          />
        </div>
      )}
    </>
  );
};

export default React.memo(Node, (prev, cur) => {
  if (
    prev.id === cur.id &&
    prev.data.title === cur.data.title &&
    prev.data?._form === cur.data?._form &&
    prev.data.tags === cur.data.tags
  ) {
    return true;
  }
  return false;
});

// const convertToNames = (tags?: NlpExtractionNodeJobData['tags']) => {
//   const names = [];
//
//   const tableTags = tags?.table_tags || [];
//
//   for (const tableTag of tableTags) {
//     const tags = tableTag?.tags || [];
//     for (const tag of tags) {
//       names.push(tag.tag_name);
//     }
//   }
//
//   const textTags = tags?.text_tags || [];
//   for (const textTag of textTags) {
//     names.push(textTag.tag_name);
//   }
//
//   return names;
// };
